// export const baseURL="http://124.222.127.76:8901"
 
const BASE_URL = "http://124.222.127.76:8901";
export default {
  BASE_URL,
};